import React, { useEffect, useState } from "react";
import { Grid, List } from "lucide-react";
import { useTranslation } from "react-i18next";

const ViewToggleSwitch = ({ viewMode = "list", onViewChange, showViewMode = true }) => {
  const { t, i18n } = useTranslation("translation");
  const [isRTL, setIsRTL] = useState(false);

  useEffect(() => {
    setIsRTL(i18n.dir() === "rtl");
  }, [i18n.language, i18n]);

  if (!showViewMode) return null;

  const getSliderStyle = () => {
    if (isRTL) {
      return {
        transform: viewMode === "list" ? "translateX(0%)" : "translateX(-100%)",
      };
    }
    return {
      transform: viewMode === "list" ? "translateX(0%)" : "translateX(100%)",
    };
  };

  return (
    <div className="oh-view-toggle">
      <div className="oh-view-toggle__slider" style={getSliderStyle()} />
      <button
        type="button"
        className={`oh-view-toggle__btn ${viewMode === "list" ? "active" : ""}`}
        onClick={() => onViewChange?.("list")}
      >
        <List size={16} />
        {t("toolBar.list")}
      </button>
      <button
        type="button"
        className={`oh-view-toggle__btn ${viewMode === "grid" ? "active" : ""}`}
        onClick={() => onViewChange?.("grid")}
      >
        <Grid size={16} />
        {t("toolBar.grid")}
      </button>
    </div>
  );
};

export default ViewToggleSwitch;
